/* eslint no-console: 0 */ // --> OFF
import * as Sentry from '@sentry/react';
import Config from 'src/common/Config';

export class Logger {
  static error(message: string, error: unknown, data?: { [key: string]: unknown }): void {
    if (Config.isDev()) {
      console.error(`message. ${JSON.stringify(data)}`, error);
    }
    Sentry.captureException(error, { data: { message, ...data } });
  }

  static warn(message: string, data?: { [key: string]: unknown }): void {
    if (Config.isDev()) {
      console.warn(`message. ${JSON.stringify(data)}`);
    }
    Sentry.captureException(new Error(`WARNING: ${message}`), { data: { message, ...data } });
  }
}
